// Detect the isolated Guangzhou warehouse portal mode.
// Warehouse domains are hardcoded below (bulletproof — independent of deploy
// env handling) and can be extended via REACT_APP_WAREHOUSE_HOST (comma list).
// Also activates via the secret path /w-a7f3c9e2 or ?warehouse=1 (per-tab test).
const BUILTIN_WAREHOUSE_HOSTS = ["yunpujiyun888.com", "www.yunpujiyun888.com"];

export function isWarehouseMode() {
  const raw = process.env.REACT_APP_WAREHOUSE_HOST || "";
  const envHosts = raw.split(",").map((h) => h.trim().toLowerCase()).filter(Boolean);
  const hosts = Array.from(new Set([...BUILTIN_WAREHOUSE_HOSTS, ...envHosts]));
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("warehouse") === "1") sessionStorage.setItem("wh_mode", "1");
    if (params.get("warehouse") === "0") sessionStorage.removeItem("wh_mode");
  } catch (_) {}
  const current = (window.location.hostname || "").toLowerCase();
  const byHost = hosts.includes(current);
  let byPath = false;
  try { byPath = window.location.pathname.startsWith("/w-a7f3c9e2"); } catch (_) {}
  let byFlag = false;
  try { byFlag = sessionStorage.getItem("wh_mode") === "1"; } catch (_) {}
  return byHost || byPath || byFlag;
}
